import { useMutation, useQueryClient } from 'react-query';

import { LocationService } from '../../services';

interface Locations {
  callerId: string;
  city: string;
  country: string;
  countryId: number;
  defaultLocation: boolean;
  location: string;
  locationId: number;
  locationName: string;
  locationNumber: string;
  outgoingPhoneNumber: string;
  state: string;
  streetName: string;
  streetNumber: string;
  timeZone: string;
  userCount: number;
  voiceEnabled: boolean;
  zip: string;
}

export const useDeleteLocation = (locationId) => {
  const queryClient = useQueryClient();

  return useMutation(() => LocationService.deleteLocation(locationId), {
    onSuccess: () => {
      const locations =
        queryClient.getQueryData<Locations[]>('locations') ?? [];

      const newLocations = locations.filter(
        (item) => item.locationId !== locationId,
      );

      queryClient.setQueryData('locations', newLocations);
    },
  });
};
